export var ReplyWithEndpointType;
(function (ReplyWithEndpointType) {
    ReplyWithEndpointType[ReplyWithEndpointType["Suggestions"] = 0] = "Suggestions";
    ReplyWithEndpointType[ReplyWithEndpointType["MRU"] = 1] = "MRU";
})(ReplyWithEndpointType || (ReplyWithEndpointType = {}));
//# sourceMappingURL=AttachmentSuggestions.js.map